// StyledSelect.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledSelectBase = styled.select`
outline: none;
height: ${({ styling }) => `${styling.selectHeight}px`};
width: ${({ styling }) => `${styling.selectWidth}${styling.selectWidthUnits}`};
border-width: ${({ styling }) => `${styling.selectBorderWidth}px`};
border-style: ${({ styling }) => `${styling.selectBorderStyleCheckbox}`};
border-color: ${({ styling }) => styling.selectBorderColor};
border-bottom: ${({ styling }) => `solid ${styling.selectBorderColor} ${styling.selectBorderWidth}px`};
padding: 0 ${({ styling }) => `${styling.selectPaddingInline}px`};
font-size: ${({ styling }) => `${styling.selectFontSize}px`};
font-weight: ${({ styling }) => styling.selectFontWeight};
font-family: ${({ styling }) => styling.selectFontFamily};
border-radius: ${({ styling }) => `${styling.selectBorderRadius}px`};
transition: ${(props) => props.theme.transitionMain};

color: ${({ styling }) => styling.selectColor};
background-color: ${({ styling }) => styling.selectBackgroundColor};
background: ${({ styling }) => `${styling.selectBackgroundColor} url('${styling.selectBackgroundImage}') no-repeat right ${styling.selectBackgroundImagePositionRight}px center`};
background-size: ${({ styling }) => styling.selectBackgroundImageSize}px;
appearance: ${({ styling }) => (styling.addSelectBackgroundImage ? "none" : "auto")};

&:hover {
  color: ${({ styling }) => styling.selectHoverColor};
  border-color: ${({ styling }) => styling.selectHoverBorderColor};
  background-color: ${({ styling }) => styling.selectHoverBackgroundColor};
}

&::placeholder {
  color: ${({ styling }) => styling.placeholderColor};
  font-size: ${({ styling }) => `${styling.placeholderFontSize}px`};
  font-weight: ${({ styling }) => styling.placeholderFontWeight};
  font-family: ${({ styling }) => styling.placeholderFontFamily};
}

&:hover::placeholder {
  color: ${({ styling }) => styling.placeholderHoverColor};
}
`;

const StyledSelect = ({ styling, ...props }) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

//   return <StyledSelectBase {...props} placeholder={placeholderText} />;
// };
return (
    <StyledSelectBase styling={styling} {...props}>
      {/* Adding a default disabled and selected option */}
      <option value="" disabled selected>
        Select
      </option>
      {/* Include other options here */}
    </StyledSelectBase>
  );
};




export default StyledSelect;
